module.exports = __webpack_public_path__ + "img/nodejs.a4a3e85d.png";